import { FiX } from "react-icons/fi";
import { HeaderLink } from "./HeaderLink";
// import logoImg from "img/logo_GMX.svg";
import logoImg from "img/avt-logo.svg";

import "./Header.css";
import { isHomeSite } from "lib/legacy";
import { Trans } from "@lingui/macro";
import React from "react";
import { Link } from "react-router-dom";
import { LANGUAGE_LOCALSTORAGE_KEY } from "config/localStorage";

import { defaultLocale, dynamicActivate } from "lib/i18n";
type Props = {
  small?: boolean;
  clickCloseIcon?: () => void;
  openSettings?: () => void;
  redirectPopupTimestamp: number;
  showRedirectModal: (to: string) => void;
};

export function AppHeaderLinks({
  small,
  openSettings,
  clickCloseIcon,
  redirectPopupTimestamp,
  showRedirectModal,
}: Props) {
  const isHome = isHomeSite();
  return (
    <div className="App-header-links">
      {small && (
        <div className="App-header-links-header">
          <Link className="App-header-link-main" to="/">
            <img src={logoImg} alt="AVT Logo" />
          </Link>
          <div
            className="App-header-menu-icon-block mobile-cross-menu"
            onClick={() => clickCloseIcon && clickCloseIcon()}
          >
            <FiX className="App-header-menu-icon" />
          </div>
        </div>
      )}

      {isHome && (
        <div className="App-header-link-container">
          {/* <HeaderLink to="/trade" redirectPopupTimestamp={redirectPopupTimestamp} showRedirectModal={showRedirectModal}>
            App
          </HeaderLink> */}
          {/* <HeaderLink to="/Dashboard" redirectPopupTimestamp={redirectPopupTimestamp} showRedirectModal={showRedirectModal}>
            <Trans>Dashboard</Trans>
          </HeaderLink> */}
          <Link to="">
            <Trans>Dashboard</Trans>
          </Link>
          {/* <Link to="/trade">
          App
        </Link> */}
        </div>
      )}
      {isHome && (
        <div className="App-header-link-container">
          {/* <HeaderLink to="/buy_glp" redirectPopupTimestamp={redirectPopupTimestamp} showRedirectModal={showRedirectModal}>
            <Trans>Buy</Trans>
          </HeaderLink> */}
          <Link to="">
            <Trans>Buy</Trans>
          </Link>
        </div>
      )}
      {isHome && (
        <div className="App-header-link-container">
          {/* <HeaderLink to="/earn" redirectPopupTimestamp={redirectPopupTimestamp} showRedirectModal={showRedirectModal}>
            <Trans>Stake and Earn</Trans>
          </HeaderLink> */}
          <Link to="">
            <Trans>Stake and Earn</Trans>
          </Link>
        </div>
      )}
      {isHome && (
        <div className="App-header-link-container">
          {/* <HeaderLink to="/referrals" redirectPopupTimestamp={redirectPopupTimestamp} showRedirectModal={showRedirectModal}>
            <Trans>Referral & Earn</Trans>
          </HeaderLink> */}
          <Link to="">
            <Trans>Referral & Earn</Trans>
          </Link>
        </div>
      )}
      {isHome && (
        <div className="App-header-link-container">
          {/* <HeaderLink
          to="/ecosystem"
          redirectPopupTimestamp={redirectPopupTimestamp}
          showRedirectModal={showRedirectModal}
        >
          <Trans>Ecosystem</Trans>
        </HeaderLink> */}
          <Link to="/bridge">
            <Trans>Bridge</Trans>
          </Link>
        </div>
      )}
      {isHome && (
        <div className="App-header-link-container">
          {/* <HeaderLink to="/referrals" redirectPopupTimestamp={redirectPopupTimestamp} showRedirectModal={showRedirectModal}>
            <Trans>About</Trans>
          </HeaderLink> */}
          <a href="https://docs.avt.trade" target="_blank" rel="noopener noreferrer">
            <Trans>About</Trans>
          </a>
        </div>
      )}
      {!isHome && (
        <div className="App-header-link-container">
          <a
            href={`https://water.test-app.fun/#/?lang=${
              localStorage.getItem(LANGUAGE_LOCALSTORAGE_KEY) || defaultLocale
            }`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Trans>Faucet</Trans>
          </a>
        </div>
      )}
      {!isHome && (
        <div className="App-header-link-container">
          <HeaderLink
            to="/dashboard"
            redirectPopupTimestamp={redirectPopupTimestamp}
            showRedirectModal={showRedirectModal}
          >
            <Trans>Dashboard</Trans>
          </HeaderLink>
          {/* <Link to="/dashboard">
            <Trans>Dashboard</Trans>
          </Link> */}
        </div>
      )}
      {!isHome && (
        <div className="App-header-link-container">
          <HeaderLink
            to="/buy_glp"
            redirectPopupTimestamp={redirectPopupTimestamp}
            showRedirectModal={showRedirectModal}
          >
            <Trans>Buy</Trans>
          </HeaderLink>
          {/* <Link to="/buy_glp">
            <Trans>Buy</Trans>
          </Link> */}
        </div>
      )}
      {!isHome && (
        <div className="App-header-link-container">
          <HeaderLink to="/earn" redirectPopupTimestamp={redirectPopupTimestamp} showRedirectModal={showRedirectModal}>
            <Trans>Stake and Earn</Trans>
          </HeaderLink>
          {/* <Link to="/earn">
            <Trans>Stake and Earn</Trans>
          </Link> */}
        </div>
      )}
      {!isHome && (
        <div className="App-header-link-container">
          <HeaderLink
            to="/referrals"
            redirectPopupTimestamp={redirectPopupTimestamp}
            showRedirectModal={showRedirectModal}
          >
            <Trans>Referral & Earn</Trans>
          </HeaderLink>
          {/* <Link to="/referrals">
            <Trans>Referral & Earn</Trans>
          </Link> */}
        </div>
      )}

      {!isHome && (
        <div className="App-header-link-container">
          {/* <HeaderLink
          to="/ecosystem"
          redirectPopupTimestamp={redirectPopupTimestamp}
          showRedirectModal={showRedirectModal}
        >
          <Trans>Ecosystem</Trans>
        </HeaderLink> */}
          <Link to="/bridge">
            <Trans>Bridge</Trans>
          </Link>
        </div>
      )}
      {!isHome && (
        <div className="App-header-link-container">
            
          <a href={`https://airdrop-app.test-app.fun/#/?lang=${
              localStorage.getItem(LANGUAGE_LOCALSTORAGE_KEY) || defaultLocale
            }`} target="_blank" rel="noopener noreferrer">
            <Trans>Ambassador program</Trans>
          </a>
        </div>
      )}
      {!isHome && (
        <div className="App-header-link-container">
          {/* <Link to="/">
            <Trans>About</Trans>
          </Link> */}
          <a href="https://docs.avt.trade" target="_blank" rel="noopener noreferrer">
            <Trans>About</Trans>
          </a>
        </div>
      )}
      {/* <div className="App-header-link-container">
        <HeaderLink to="/buy_glp" redirectPopupTimestamp={redirectPopupTimestamp} showRedirectModal={showRedirectModal}>
          <Trans>BuyGLP</Trans>
        </HeaderLink>
      </div> */}
      {/* <div className="App-header-link-container">
        <HeaderLink
          to="/referrals"
          redirectPopupTimestamp={redirectPopupTimestamp}
          showRedirectModal={showRedirectModal}
        >
          <Trans>Referrals</Trans>
        </HeaderLink>
      </div>
      <div className="App-header-link-container">
        <HeaderLink
          to="/ecosystem"
          redirectPopupTimestamp={redirectPopupTimestamp}
          showRedirectModal={showRedirectModal}
        >
          <Trans>Ecosystem</Trans>
        </HeaderLink>
      </div>
      <div className="App-header-link-container">
        <a href="https://gmxio.gitbook.io/gmx/" target="_blank" rel="noopener noreferrer">
          <Trans>About</Trans>
        </a>
      </div> */}
      {small && !isHomeSite() && (
        <div className="App-header-link-container">
          {/* eslint-disable-next-line */}
          <a href="#" onClick={openSettings}>
            <Trans>Settings</Trans>
          </a>
        </div>
      )}
    </div>
  );
}
